import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';
import { GeneralTeacherComponent } from '../../General/gt.component';

@Component({
  selector: 'app-t-ct-compute-bits',
  templateUrl: './t-ct-compute-bits.component.html',
  styleUrls: ['./t-ct-compute-bits.component.css']
})
export class TCtComputeBitsComponent extends GeneralTeacherComponent {
  message: string;
  dimension: number[] = [0, 0];
  modus: string;
  encoding: string = "cardTrick";
  useSymbols: boolean = false;

  length: number;
  hamming: string;

  showMessage: string;

  messageArray: number[][] = [];

  c: number[] = [];
  p: string[] = [];

  highlight: boolean = false;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute);
    this.type = "controlBits";
    this.title = this.get("controlBits");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.message = this.configuration.typespecifics.message;
    this.dimension = this.configuration.typespecifics.dimension ? this.configuration.typespecifics.dimension : [];
    this.modus = this.configuration.typespecifics.modus;
    this.encoding = this.configuration.typespecifics.encoding;
    this.highlight = this.configuration.typespecifics.highlight;
    this.useSymbols = this.configuration.typespecifics.useSymbols;
    this.computeShowMessage();


    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/computeBits.png";
    definition.level = 1;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.message = this.message;
    definition.typespecifics.dimension = this.dimension;
    definition.typespecifics.modus = this.modus;
    definition.typespecifics.encoding = this.encoding;
    definition.typespecifics.highlight = this.modus == "encode" ? this.highlight : false;
    definition.typespecifics.useSymbols = this.modus == "controlBits" && this.encoding == 'cardTrick' ? this.useSymbols : false;
    if (this.encoding == "cardTrick") {
      definition.key = definition.key.concat("%", this.message, "%", this.encoding.toString(), "%", this.dimension.toString(), "%", definition.typespecifics.modus.toString());
    } else {
      definition.key = definition.key.concat("%", this.message, "%", this.encoding.toString(), "%", definition.typespecifics.modus.toString());
    }

    return definition;

  }

  generate() {
    this.title = this.get("controlBits");
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    this.message = this.generate01(this.dimension[0] * this.dimension[1])
    this.modus = Math.random() > 0.5 ? 'controlBits' : 'encode';
    this.encoding = "cardTrick";
    this.highlight = true;
    this.computeShowMessage();


    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();

    this.computeLength();
  }

  /** generates a 01-string of given length
   * @param length - length of string
   */
  generate01(length: number) {
    let result = "";
    for (let i = 0; i < length; i++) {
      result = result.concat((Math.random() > 0.5 ? "0" : "1"));
    }
    return result;
  }

  /** recomputes the message array assignments */
  changeDimension() {
    this.message = this.messageArray.map(v => v.join("")).join("");
    this.messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      this.messageArray.push(elem);
    }
    this.length = this.dimension[0] * this.dimension[1];
  }

  /** fills the message array based on dimension and message */
  fillArray() {
    if (this.encoding == "cardTrick") {
      this.messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        this.messageArray.push(elem);
      }
    }
  }

  /** normalizes the message */
  normalize(s: string): string {
    if (!s) {
      return "";
    }
    return s.replace(/[^01]/, "");
  }

  /** recomputes the control bits */
  changeMessage() {
    if (this.encoding == "cardTrick") {
      this.controlBits()
    } else {
      this.computeShowMessage();
      this.hammingCode();
    }
  }

  /** computes the comtroll bits */
  controlBits() {
    this.c = this.selfcorrectingService.controlBits(this.messageArray, this.dimension);
    this.message = this.messageArray.map(v => v.join("")).join("");
  }

  /** computes the correct hamming code */
  hammingCode() {
    this.length = 11;
    this.p[0] = "";
    this.p[1] = "";
    this.p[2] = "";
    this.p[3] = "";
    for (let i of this.selfcorrectingService.allCodes(4)) {
      if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
        for (let j = 0; j < 4; j++) {
          if (i.charAt(j) == "1") {
            this.p[3 - j] = this.p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
          }
        }
      }
    }
    this.c = this.p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);
  }

  /** encodes the given number as code
   * @param i - number to encode
   * @param length - length of code
   */
  toString(i: number, length: number) {
    return "0".repeat(length).concat(i.toString(2)).slice(-length);
  }

  /** computes the expected length of the message */
  computeLength() {
    if (this.encoding == "cardTrick") {
      this.length = this.dimension[0] * this.dimension[1];
    } else {
      this.length = 11;
    }
  }

  /**
   * checks whether the given number is a power of 2
   * @param x - number to check
   */
  powerOfTwo(x: number): boolean {
    return (Math.log(x) / Math.log(2)) % 1 === 0
  }

  /**
   * computes 2^i
   * @param i - power
   */
  pow2(i: number): number {
    return Math.pow(2, i);
  }

  /**
   * computes the message zu show
   */
  computeShowMessage() {
    let dataI = 0;
    this.showMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        this.showMessage = this.showMessage.concat("c");
      } else {
        this.showMessage = this.showMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }
  }

  reset() {
    super.reset();
    this.title = this.get("controlBits");
    this.message = undefined;
    this.dimension = [0, 0];
    this.modus = undefined;
    this.encoding = "cardTrick";
    this.useSymbols = false;
    this.highlight = false;
    this.messageArray = [];


  }

}
